//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SVGLoader',
  props: {
    icon: {
      type: String,
      required: true
    },
    width: {
      type: Number,
      required: true
    },
    height: {
      type: Number,
      required: true
    },
    htmlAttrs: {
      type: Object,
      default: () => {}
    }
  },
  data: () => {
    return { iconMap: getIconMap() };
  }
}

function getIconMap() {
  return {
    default: {
      xmlns: 'http://www.w3.org/2000/svg'
    },
    phone: {
      viewBox: '0 0 48 48'
    },
    email: {
      viewBox: '0 -2.5 20 20'
    },
    advisors: {
      viewBox: '-3 0 32 32',
      fill: "#FFFFFF",
      stroke: "#FFFFFF",
      strokeWidth: 0.7
    },
    award: {
      viewBox: '0 0 56 56',
    },
    house: {
      viewBox: '0 0 16 16',
    }
  }
}
